// import { Modal, Button, message } from "antd";
import {
  DownloadOutlined,
  FileExcelOutlined,
  FileOutlined,
} from "@ant-design/icons";
import { Button, message, Modal } from "antd";

const ImagePreviewModal = ({
  open,
  onClose,
  imageUrl,
  fileName,
  fileType,
}) => {
  const handleDownload = () => {
    
    if (!imageUrl) return;

    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();

    message.success("File downloaded successfully.");
  };

  return (
    <Modal open={open} onCancel={onClose} footer={null} centered width={600}>
      <div style={{ textAlign: "center" }}>
        {/* IMAGE PREVIEW */}
        {fileType === "image" && (
          <img
            src={imageUrl}
            alt="Preview"
            style={{
              width: "100%",
              maxHeight: 400,
              objectFit: "contain",
            }}
          />
        )}

      
{/* PDF & OTHER FILES */}
        {(fileType === "pdf" || fileType === "other") && (
          <>
            {fileType === "pdf" ? (
              <FileOutlined style={{ fontSize: 48, color: "#ff4d4f" }} />
            ) : (
              <FileExcelOutlined style={{ fontSize: 48, color: "#52c41a" }} />
            )}

            <p style={{ marginTop: 10, wordBreak: "break-all" }}>
              {fileName}
            </p>
          </>
        )}
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          onClick={handleDownload}
          style={{ marginTop: 20 }}
          disabled={!imageUrl}
        >
          Download
        </Button>
      </div>
    </Modal>
  );
};

export default ImagePreviewModal;
